import React, {useEffect, useState} from 'react';
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "../../shadCn/components/ui/table";
import {useNavigate} from "react-router-dom";
import PaginationCustom from "./PaginationCustom";
import NoImage from "../../resources/icon/noImage.png";
import FilterBasic from "../filter/FilterBasic";
import SortBasic from "./SortBasic";
import EmptyData from "../../resources/icon/empty-data.png"
import {Button} from "../../shadCn/components/ui/button";
import {checkOutComputerRoom} from "../../api/computerRoom/ComputerRoomService";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";

/**
 * `테이블 `기본테이블
 * header: 테이블 헤더의 각 칼럼명
 * option: 옵션 => 행 클릭시 이동할 주소, 테이블이 화면상에서 차지할 넓이
 * data: 리소스 서버에서 가져온 리스트
 * paged : {pageable, setPageable} => pageable : 페이지 정보(스프링의 pegable 객체)  /  paged.setPageable : 페이지 네이션에 의해 조작되는 페이지 정보를 세팅할 메서드
 * size : 한페이지에 몇개의 컨텐츠 표시되는지.
 * checked : {checked, setChecked}} => 체크된 값( data.id )을 넘겨줌.
 * button : {text : [], listener : [], class : []} 버튼이 있는 td는 상세페이지 이동 비활성화
 * img : true, false로 사용유무 제여
 *  @@ header @@
 *  {name: "이름", field: "key", width: 18, minWidth: 250} => data.key 를 "이름" 이라는 칼럼에 넓이 18% 이고 최소로는 250px 차지하도록 한다.  이런식으로 각 칼럼에 대한 정보를 배열로 넘기면 된다.
 *  notUse {checkbox : true, number : true} 각 필드별로 true를 걸면 해당 필드가 설정되지 않도록 설정
 *  removeLink : true > 모든행의 링크기능 제거
 * */

function TableEquipment({header, option, data, paged, checked, size, notUse, removeLink}) {

    const IMG_BASE = import.meta.env.VITE_IMG_BASE

    const [filterOpen, setFilterOpen]= useState(false); // 필터 팝업여부
    const [tableTh, setTableTh]=useState(header);

    const navigate = useNavigate();
    const movePage = (id) => {
        // let state;
        // if(option.state)
        //     state = option.state;
        // else
        //     state = {id : id}
        // navigate(
        //     `${option.url}/${id}`,
        //     { state: state }
        // );
    }
    const [isHeaderChecked, setIsHeaderChecked] = useState(false);

    const handleHeaderCheckboxClick =()=>{
        setIsHeaderChecked(prev => !prev);
        if (!isHeaderChecked) {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => [...new Set([...prevItems, ...currentPageIds])]);
        } else {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => prevItems.filter((item) => !currentPageIds.includes(item)));
        }
    }

    const handleCheckboxClick = (value) => {
        const isChecked = checked.checked && checked.checked.includes(value);
        if (isChecked) {
            checked.setChecked((prevItems) => prevItems.filter((item) => item !== value));
        } else {
            checked.setChecked((prevItems) => [...prevItems, value]);
        }
        updateHeaderChkbox();
        }

    function updateHeaderChkbox() {
        if (data && data.length > 0) {
        const allChecked = data.every((item) => checked.checked.includes(item.id));
        setIsHeaderChecked(allChecked);
        } else {
            setIsHeaderChecked(false);
        }
    };

    const filterListener=()=>{
        setFilterOpen(!filterOpen)
    }
    const ttest=()=>{
        console.log(tableTh)

    }

    useEffect(() => {
        updateHeaderChkbox()
    }, [data, checked.checked,tableTh]);





    return (
        <div style={{width: option.width+`%`}} >
            <div className="mb-2 relative text-left">
                <span className="totalElements" onClick={ttest}>
                총 {paged.pageable.totalElements} 건
                </span>
                <div className="inline-block float-right" onClick={filterListener}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                         stroke="currentColor" className="w-6 h-6 inline-block">
                        <path strokeLinecap="round" strokeLinejoin="round"
                              d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"/>
                    </svg>
                </div>
                {filterOpen &&
                    <FilterBasic data={{data:header ,th:tableTh, fnc:setTableTh}} setFilterOpen={setFilterOpen}/>
                }
            </div>
            <div className="h-[386px] text-center">
            <Table className="table-border common-table">
                <TableHeader className="table-head">

                        <tr className="table-head-row" >



                            {tableTh.map((th, index) => {
                                const styles = {};
                                if (th.width && !th.exWidth) {
                                    styles.width = th.width + `%`;
                                }
                                if (th.minWidth) {
                                    styles.minWidth = th.minWidth + `px`;
                                }
                                if (th.exWidth) {
                                    styles.width = th.exWidth + `px`;
                                }


                                return (
                                    <TableHead className="common-table-th text-center whitespace-pre-line whitespace-break-spaces" key={index} style={styles}>


                                            {th.name}

                                        {/*{! th.exSort &&*/}
                                        {/*    < SortBasic target={th.field} paged={paged}/>*/}
                                        {/*}*/}

                                    </TableHead>


                                );

                            })}
                        </tr>


                </TableHeader>
                <TableBody className="table-body">
                    {data && data.length > 0 ? (data.map((item, rowIndex) => (

                            <TableRow key={rowIndex} onClick={removeLink ? (e) => {
                                e.stopPropagation()
                            } : () => movePage(item.id)} className="cursor-pointer">

                                {!notUse?.checkbox &&
                                    <td className="text-center  chk-box-col " onClick={(e) => {
                                        e.stopPropagation();
                                        handleCheckboxClick(item.id)
                                    }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={checked.checked && checked.checked.includes(item.id)}
                                            onChange={() => (item.id)}
                                        />
                                    </td>
                                }
                                {!notUse?.number &&
                                    <td className="text-center td-br h-[40px]" onClick={removeLink ? (e) => {
                                        e.stopPropagation()
                                    } : () => movePage(item.id)}>{paged.pageable.page * size + rowIndex + 1}</td>
                                }
                                {tableTh.map((th, colIndex) => (
                                    <TableCell className="border-1-e2e" key={colIndex}
                                               onClick={th.button || removeLink ? (e) => {
                                                   e.stopPropagation()
                                               } : () => movePage(item.id)}>


                                        <>
                                            {

                                                Array.isArray(th.field)
                                                    ?
                                                    <>
                                                        {th.field.map((each, index)=>

                                    Array.isArray(tableTh[colIndex].label) ?
                                        <p key={index}>{item[th.field[index]] && typeof item[th.field[index]] === 'object' ?
                                            tableTh[colIndex].label[index]+" : "+(item[th.field[index]].name ? item[th.field[index]].name : '') :
                                            tableTh[colIndex].label[index]+" : "+(item[th.field[index]] ? item[th.field[index]] : '')
                                        }
                                        </p>
                                        : <p key={index}>{item[th.field[index]] && typeof item[th.field[index]] === 'object' ? item[th.field[index]].name: item[th.field[index]] }</p>


                                                        )}

                                </>
                                :

                                                    (item[th.field] && typeof item[th.field] === 'object' ? item[th.field].name : item[th.field] === true ?console.log(item) :item[th.field])

                            }
                                            

                            {
                                th.button &&
                                    <>
                                        {th.button.text.map((each,index)=>
                                            <div className={th.button.class[index]}  onClick ={th.button.listener[index]}>{th.button.text[index]}</div>
                                        )}
                                    </>
                            }

                            {
                                // uploadName,thumbnail, path
                                th.img &&
                                (item[th.field] ?
                                    <div className="w-[40px] p-[3px]">
                                    <img className="w-[40px] block " src={
                                        item[th.field][0].thumbnail && item[th.field][0].thumbnail ? IMG_BASE + item[th.field][0].path + "thumb_"+item[th.field][0].uploadName :
                                            IMG_BASE + item[th.field][0].path +item[th.field][0].uploadName
                                    } alt={"이미지 설명"} />
                                    </div>
                                 :
                                    <div className="w-[40px] h-[40px] p-[3px]">
                                        <img className="w-[40px] align-middle" src={NoImage} alt={"이미지 설명"} />
                                    </div>
                                )
                            }
                            </>

                        </TableCell>
                            ))}
                    </TableRow>
                            ))
                    ):(
                        <>
                            <TableRow className="common-table-nodata-tr">
                                <TableCell className="table-no-data text-center" colSpan={ !notUse? tableTh.length+2 :
                                        notUse?.checkbox && notUse?.number ? tableTh.length :
                                        notUse?.checkbox || notUse?.number ? tableTh.length + 1 : tableTh.length+2}>
                                    <img src={EmptyData} className="w-[70px] m-auto mb-3"/>
                                    <span className="">내역이 없습니다.</span>
                                </TableCell>
                            </TableRow>
                        </>
                    )}
                </TableBody>
            </Table>
            </div>
            {data && data.length > 0 && (paged.totalPages > 1 || paged.pageable?.totalPages > 1) &&
                < PaginationCustom paged={paged} />
            }
        </div>
    );
}

export default TableEquipment;